(function () {
  // Dateinamen-Suffix (vor der Endung): ...-ki-g.(jpg|png|webp|…) = KI-generiert, ...-ki-b.… = KI-bearbeitet
  var MAP = { g: 'KI-generiert', b: 'KI-bearbeitet' };
  var RE  = /[-_]ki-(g|b)(?=[._]|$)/;   // nur am Dateinamen-Ende; robust gegen _800x-Größen & ?query

  function url(img) {
    return img.currentSrc || img.getAttribute('src') || '';
  }

  function pickHost(img) {
    // bevorzugt bekannte Bild-Wrapper
    var host = img.closest('.media-wrapper, .card__media, .tee-mockup-item, .media');
    if (host) return host;
    // sonst Elternelement – aber niemals <picture> (zerstört sonst die Bildausgabe)
    host = img.parentElement;
    while (host && host.tagName === 'PICTURE') host = host.parentElement;
    return host;
  }

  function tag(img) {
    if (img.dataset.kiDone) return;
    var u = url(img);
    // Platzhalter/Lazy noch nicht geladen -> nicht als erledigt markieren, später erneut prüfen
    if (!u || u.indexOf('data:') === 0 || u.indexOf('loading.svg') !== -1) return;

    var m = u.split('?')[0].toLowerCase().match(RE);
    img.dataset.kiDone = '1';
    if (!m) return;

    var text = MAP[m[1]];
    var host = pickHost(img);
    if (!host || host.querySelector('.ki-label')) return;   // kein Doppel-Label (z. B. wo Metafeld schon greift)
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';

    var s = document.createElement('span');
    s.className = 'ki-label ki-label--' + text.toLowerCase();  // -> ki-label--ki-generiert / --ki-bearbeitet
    s.setAttribute('title', text);
    s.textContent = text;
    host.appendChild(s);
  }

  function scan() {
    document.querySelectorAll('img').forEach(tag);
  }

  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', scan);

  // fängt lazy nachgeladene Bilder, async-Module und src-Wechsel
  new MutationObserver(scan).observe(document.body, {
    childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'srcset']
  });
})();